import '../../styles/web-components/mobile-hp-nav.scss';
class MobileHPNav extends HTMLElement {
    constructor() {
        super();
        this.catLists = Array.from(document.querySelectorAll(".mobile-hp-nav__category-list"));
        this.addEventListener("change", (e) => {
            const target = e.target;
            if (target.matches(".mobile-hp-nav__input")) {
                const selectedCatNav = target.value;
                console.log(selectedCatNav);
                this.catLists.forEach((list) => list.classList.add("hidden"));
                const selectedList = this.catLists.find((list) => list.dataset.navId === selectedCatNav);
                if (selectedList) {
                    selectedList.classList.remove("hidden");
                }
                this.updateDisplay();
            }
            document.addEventListener("resize", () => {
                this.updateDisplay();
            });
        });
    }
    updateDisplay() {
        const initLeftPad = 24;
        const spaceToFill = window.innerWidth - initLeftPad;
        const baseGap = 8;
        const listItemWidth = 84;
        const totalListItemWith = listItemWidth + baseGap;
        const numElementsToDisplay = Math.ceil(spaceToFill / totalListItemWith);
        const catContainerEl = document.querySelector(".mobile-hp-nav__category-list:not(.hidden)");
        const totalNumElements = catContainerEl.children.length;
        if (numElementsToDisplay < totalNumElements) {
            console.log("updating num shown");
            const numWithPeek = numElementsToDisplay - 0.5; // 4.5
            const numWithPeekPixels = numWithPeek * totalListItemWith;
            const numWithoutPeek = numElementsToDisplay - 1;
            const addToGap = (spaceToFill - numWithPeekPixels) / numWithoutPeek;
            console.debug("spaceToFill: " +
                spaceToFill +
                ", numElementsToDisplay: " +
                numElementsToDisplay +
                ", totalNumElements: " +
                totalNumElements +
                ", numWithPeek: " +
                numWithPeek +
                ", numWithPeekPixels: " +
                numWithPeekPixels +
                ", numWithoutPeek: " +
                numWithoutPeek +
                ", addToGap: " +
                addToGap);
            const newGap = addToGap < 0 ? baseGap : baseGap + addToGap;
            catContainerEl.style.gap = newGap + "px";
        }
        else {
            catContainerEl.style.gap = baseGap + "px";
        }
    }
}
if (!window.customElements.get("mobile-hp-nav")) {
    customElements.define("mobile-hp-nav", MobileHPNav);
}
